import React from 'react';
import { Icon } from './Icon.js';
export const IconRadioCheckedFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm0,11c-1.654,0-3-1.346-3-3s1.346-3,3-3,3,1.346,3,3-1.346,3-3,3Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconRadioCheckedFill18.js.map